import Pressable from '~/shared/Pressable';
import { HStack } from 'native-base';
import { Caption } from '~/shared/Typography';
import React from 'react';
import { useAppSettings, useSpringBigStore } from '@springbig/shared';
import { useCopyToClipboard } from 'usehooks-ts';
import { useToast } from '~/hooks/toast';

const Debug = (() => {

    const [value, copy] = useCopyToClipboard();
    const { successToast } = useToast();

    const {
        merchant,
        member,
        walletId,
        apiEnv,
    } = useSpringBigStore();

    const {
        merchantOrg,
    } = useAppSettings();

    const onCopyMetaData = (): void => {

        copy(`env: ${apiEnv} | merchant id: ${merchant.id} | org: ${merchantOrg} | member id: ${member.id} | wallet id: ${walletId}`);
        successToast('copied to clipboard');
    };

    return (
        <>
            { apiEnv !== 'production' &&
                <Pressable
                    position={'absolute'}
                    top={0}
                    left={'50%'}
                    style={{
                        transform: 'translateX(-50%)',
                    }}
                    onPress={onCopyMetaData}
                >
                    <HStack
                        bg={'white'}
                        px={1}
                        space={1}
                        fontSize={9}
                        roundedBottom={3}
                    >
                        <Caption
                            color={'black'}
                            fontSize={'inherit'}
                        >
                            { apiEnv }
                        </Caption>
                        <Caption
                            color={'black'}
                            fontSize={'inherit'}
                        >
                            |
                        </Caption>
                        <Caption
                            color={merchant ? 'green' : 'red'}
                            fontSize={'inherit'}
                        >
                            merchant
                        </Caption>
                        { merchant?.id ?
                            <Caption
                                color={'black'}
                                fontSize={'inherit'}
                            >
                                { merchant?.id }
                            </Caption>
                            :
                            <Caption
                                color={'red'}
                                fontSize={'inherit'}
                            >
                                &#9888;
                            </Caption>
                        }
                        <Caption
                            color={'black'}
                            fontSize={'inherit'}
                        >
                            |
                        </Caption>
                        <Caption
                            color={'black'}
                            fontSize={'inherit'}
                        >
                            { merchantOrg }
                        </Caption>
                        <Caption
                            color={'black'}
                            fontSize={'inherit'}
                        >
                            |
                        </Caption>
                        <Caption
                            color={member ? 'green' : 'red'}
                            fontSize={'inherit'}
                        >
                            member
                        </Caption>
                        { member?.id ?
                            <Caption
                                color={'black'}
                                fontSize={'inherit'}
                            >
                                { member?.id }
                            </Caption>
                            :
                            <Caption
                                color={'red'}
                                fontSize={'inherit'}
                            >
                                &#9888;
                            </Caption>
                        }
                        <Caption
                            color={walletId ? 'black' : 'red'}
                            fontSize={'inherit'}
                            numberOfLines={1}
                            ellipsizeMode="tail"
                        >
                            { walletId || 'no wallet id' }
                        </Caption>
                        { localStorage.getItem('theme_id') &&
                            <Caption
                                color={'orange'}
                                fontSize={'inherit'}
                                numberOfLines={1}
                                ellipsizeMode="tail"
                            >
                                | theme preview
                            </Caption>
                        }
                    </HStack>
                </Pressable>
            }
        </>
    );
});

export default Debug;
